import { action, observable, computed } from 'mobx';
import BaseModalStore from '@src/components/modal-container/base-modal-store';

class PhotoDetailModalStore extends BaseModalStore {
  // 图片大图展示地址
  @observable src = '';
  @computed
  get name() {
    return this.src.split('/').pop() || 'downloaded_image';
  }

  downloadCrossOriginImage = async () => {
    try {
      // 先获取图片并转换为blob
      const response = await fetch(this.src, {
        mode: 'cors',
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      });

      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);

      // 然后使用方法2下载
      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = this.name || 'image.png';
      document.body.appendChild(link);
      link.click();

      // 清理
      document.body.removeChild(link);
      URL.revokeObjectURL(objectUrl);
    } catch (error) {
      console.error('下载失败:', error);
    }
  };

  @action
  onClickClose = () => {
    this.isOpen = false;
    this.isActive = false;
    this.src = '';
  };

  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  use() {
    super.use();
  }
}

export default PhotoDetailModalStore;
